import React from 'react'
import classnames from 'classnames'

import { Item } from '../../../core/items'
import { SupportedLanguageCode, LANGUAGE_CODES } from '../../../core/i18n'
import { matchItemInfoTableContent } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'
import formStyles from '../../styles/modules/each-item/each-item-forms.module.scss'

interface Props {
  item: Item
  activeLanguage: SupportedLanguageCode
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void
}

const MatchItemInfoForm: React.FC<Props> = props => {
  const isEnglishMode = props.activeLanguage === LANGUAGE_CODES.ENGLISH
  
  return (
  <div
    className={classnames({
      [styles.wrapper]: true,
      [styles.stocker]: true,
    })}
  >
    <table className={styles.container}>
      <tbody>
        <tr className={styles.inputRowStatic}>
          <td className={styles.inputCell}>
            {matchItemInfoTableContent.bitterness}
          </td>
          <td className={styles.inputCell}>
            <input
              className={formStyles.input}
              value={props.item.matchItemParam.bitterness}
              onChange={props.onChange}
              name="bitterness"
              disabled={isEnglishMode}
            />
          </td>
        </tr>
        <tr className={styles.inputRowStatic}>
          <td className={styles.inputCell}>
            {matchItemInfoTableContent.fragrance}
          </td>
          <td className={styles.inputCell}>
            <input
              className={formStyles.input}
              value={props.item.matchItemParam.fragrance}
              onChange={props.onChange}
              name="fragrance"
              disabled={isEnglishMode}
            />
          </td>
        </tr>
        <tr className={styles.inputRowStatic}>
          <td className={styles.inputCell}>
            {matchItemInfoTableContent.acidity}
          </td>
          <td className={styles.inputCell}>
            <input
              className={formStyles.input}
              value={props.item.matchItemParam.acidity}
              onChange={props.onChange}
              name="acidity"
              disabled={isEnglishMode}
            />
          </td>
        </tr>
        <tr className={styles.inputRowStatic}>
          <td className={styles.inputCell}>
            {matchItemInfoTableContent.sweetness}
          </td>
          <td className={styles.inputCell}>
            <input
              className={formStyles.input}
              value={props.item.matchItemParam.sweetness}
              onChange={props.onChange}
              name="sweetness"
              disabled={isEnglishMode}
            />
          </td>
        </tr>
        <tr className={styles.inputRowStatic}>
          <td className={styles.inputCell}>
            {matchItemInfoTableContent.richness}
          </td>
          <td className={styles.inputCell}>
            <input
              className={formStyles.input}
              value={props.item.matchItemParam.richness}
              onChange={props.onChange}
              name="richness"
              disabled={isEnglishMode}
            />
          </td>
        </tr>
        <tr className={styles.inputRowStatic}>
          <td className={styles.inputCell}>
            {matchItemInfoTableContent.uniqueness}
          </td>
          <td className={styles.inputCell}>
            <input
              className={formStyles.input}
              value={props.item.matchItemParam.uniqueness}
              onChange={props.onChange}
              name="uniqueness"
              disabled={isEnglishMode}
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  )
}

export default MatchItemInfoForm
